<template>
	
	<v-app v-if="showLayout == true">

		<!-- sidebar -->
	  <v-navigation-drawer
	    v-model="showSidebar"
	    fixed
	    app
	    id="sidebar"
	  >

	  	<!-- logo -->
	  	<v-list-item to="/">
        <v-list-item-content>
          <v-list-item-title class="text-h6 text-center">
            <img src="@/assets/img/logo.png" width="100px">
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <!-- items -->
	    <v-list>
	      <v-list-item
	        v-for="item in items"
	        :to="item.to"
	        router
	        exact
	      >
	        <v-list-item-action>
	          <v-icon>{{ item.icon }}</v-icon>
	        </v-list-item-action>
	        <v-list-item-content>
	          <v-list-item-title><small class="sid-title">{{ item.title }}</small></v-list-item-title>
	        </v-list-item-content>
	      </v-list-item>
	    </v-list>

	  </v-navigation-drawer>


	  <!-- barra superior -->
	  <v-app-bar
	    fixed
	    app
	    id="cms-nav-top"
	  >

	  	<!-- opt expandir sidebar -->
	    <v-app-bar-nav-icon @click.stop="showSidebar = !showSidebar" />

	    <v-spacer />


	    <!-- notificaciones -->
	    <v-menu
	      v-model="showNotifications"
	      :close-on-content-click="false"
	      :nudge-width="200"
	      offset-y
	      light
	    >
	      <template v-slot:activator="{ on, attrs }">
	        <v-btn
	          v-bind="attrs"
	          v-on="on"
	          text
	          class="mr-5"
	          @click="seeNotifications()"
	        >
	          <v-icon>mdi-bell</v-icon>
	          <v-icon v-if="pointNotification" color="primary" size="15" id="point-notification">mdi-circle</v-icon>
	        </v-btn>
	      </template>

	      <v-card style="max-width: 350px;">

	        <v-list>
	          <v-list-item v-if="notifications.length == 0">
	            <v-list-item-content>
	              <v-list-item-subtitle>No tienes notificaciones</v-list-item-subtitle>
	            </v-list-item-content>
	          </v-list-item>

	          <div v-for="notify in notifications">
	          	<v-list-item class="mt-1">
	          	  <v-list-item-content>
	          	    <v-list-item-subtitle style="white-space: normal;">
	          	    	<span>{{notify.text}}</span> <br>
	          	    	<small style="float: right;">{{datetimeFormat2(notify.created_at)}}</small>
	          	    </v-list-item-subtitle>
	          	  </v-list-item-content>
	          	</v-list-item>
	          	<v-divider></v-divider>
	          </div>

	          <v-divider></v-divider>
	        </v-list>

	        <v-card-actions style="margin-top: -8px;">
	        	<v-spacer></v-spacer>
	          <v-btn
	            color="primary"
	            text
	            @click="showNotifications = false"
	            to="/cms/notificaciones/"
	          >
	            Mostrar todas
	          </v-btn>
	          <v-spacer></v-spacer>
	        </v-card-actions>

	      </v-card>

	    </v-menu>
	    

	    <!-- perfil -->
	    <v-menu 
	    	offset-y 
	    	light
	    >

        <template v-slot:activator="{ on, attrs }">
        	<v-btn 
        		v-bind="attrs"
        		v-on="on"
        		text
        	>
        		<v-icon color="primary">mdi-account-circle</v-icon>
          	ADMIN.
         	</v-btn>
        </template>

        <v-card>

	        <v-list>
	          <v-list-item link to="/cms/cambiar_clave/"> 
	          	<v-list-item-content>
	            	<v-list-item-subtitle>Cambiar contraseña</v-list-item-subtitle>
	            </v-list-item-content>
	          </v-list-item>
	          <v-divider></v-divider>
	          <v-list-item link @click="logout()">
	          	<v-list-item-content>
	            	<v-list-item-subtitle>Salir</v-list-item-subtitle>
	            </v-list-item-content>
	          </v-list-item>
	        </v-list>

	      </v-card>

      </v-menu>

	  </v-app-bar>


	  <!-- main -->
	  <v-main id="main">

	  	<v-container id="main-container">
	  		
	  		<h3 id="cms-title">
	  			<slot name="title" />
	  		</h3>

		  	<div id="main-content">
		  		
		  		<h5 id="main-subtitle">
		  			<slot name="subtitle" />
		  		</h5>

		  		<div>
		  			<slot name="content" />
		  		</div>

		  	</div>

	  	</v-container>	

	  </v-main>


	  <!-- footer -->
	  <v-footer
	    :absolute="true"
	    app
	    id="cms-footer"
	  >
	    <small>&copy; {{ new Date().getFullYear() }} - WOW ENVIOS</small>
	  </v-footer>

	</v-app>
	
</template>


<style>
	
	#sidebar {
		background: #09192A;
		min-height: 100%;
	}

	.sid-title {
		letter-spacing: .0892857143em
	}

	#cms-nav-top {
		background: #09192A;
	}

	#main {
		background: #E5EBF2;
		color: black;
	}

	#cms-footer {
		z-index: 1000;
		background: #09192A;
	}

	#cms-footer small {
		font-weight: 500;
		letter-spacing: .0892857143em;
	}

	#cms-title {
		letter-spacing: .0892857143em;
		border-bottom: 1px solid #C7D1DD;
		padding-bottom: 10px;
	}

	#main-container {
		padding: 25px;
	}

	#main-content {
		background: white;
		margin-top: 30px;
		border-radius: 5px;
		border: solid 1px #ddd;
		padding: 0px;
		padding-bottom: 10px;
	}

	#main-subtitle {
		letter-spacing: .0892857143em;
		border-bottom: 1px solid #C7D1DD;
		padding: 10px;
	}

	#point-notification {
		position: absolute;
		top: -3px;
		right: 1px;
	}

</style>


<script>

	import NotificationService from '@/shared/services/NotificationService'

	import UserService from '@/shared/services/UserService'


	export default 
	{

	  name: 'CmsLayout',

	  data () {
	    return {

	    	showLayout: false,

	      showSidebar: false,

	      // items sidebar
	      items: [
	        {
	          icon: 'mdi-monitor-dashboard',
	          title: 'PANEL DE CONTROL',
	          to: '/cms'
	        },
	        {
	          icon: 'mdi-account',
	          title: 'CLIENTES',
	          to: '/cms/clientes/'
	        },
	        {
	          icon: 'mdi-send',
	          title: 'ENVÍOS',
	          to: '/cms/envios/'
	        },
	        {
	          icon: 'mdi-api',
	          title: 'CUENTAS API',
	          to: '/cms/cuentas-api/'
	        },
	        {
	          icon: 'mdi-package',
	          title: 'PAQUETERÍAS',
	          to: '/cms/paqueterias/'
	        },
	        {
	          icon: 'mdi-hand-coin',
	          title: 'METODOS DE PAGO',
	          to: '/cms/metodos-pago/'
	        },
	        {
	          icon: 'mdi-cogs',
	          title: 'CONFIGURACIÓN GNR.',
	          to: '/cms/configuracion-general/'
	        },
	        {
	          icon: 'mdi-scale-balance',
	          title: 'TÉRMINOS Y PRIVACIDAD',
	          to: '/cms/terminos-privacidad/'
	        },
	        {
	          icon: 'mdi-post',
	          title: 'BLOG',
	          to: '/cms/blog/'
	        },
	      ],


	      showNotifications: false,
	      pointNotification: false,
	      notifications: [],
	      notifyFunctionInterval: null,

	      user_id: null
	    }
	  },


	  async created()
	  {
	  	if(screen.width > 1263)
	  		this.showSidebar = true

	  	this.showLayout = true


	  	const resp = await UserService.getUser()
	  	this.user_id = resp.data.id


	  	this.notify()
	  	this.notifyFunctionInterval = setInterval(()=> this.notify(), 5000)
	  },


	  destroyed() {
			clearInterval(this.notifyFunctionInterval)
		},


	  methods: {

	  	logout()
			{
				localStorage.clear()
				this.$router.push('/')
			},

			async notify()
			{
				const resp = await NotificationService.get(this.user_id)

				this.notifications = resp.data.notifications

				if(resp.data.status == 'no-see')
					this.pointNotification = true
				else 
					this.pointNotification = false
			},

			seeNotifications() {
				NotificationService.seeNotifications(this.user_id)
			},

	  }

	}

</script>